import { Box, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { LoadingButton } from "../../../components/button/Button";
import { useEffect, useState } from "react";
import Spinner from "../../../components/spinner/Spinner";
import {
  useGetDetailExpense,
  useAddExpense,
  useUpdateExpense,
} from "../network/resolver";
import { InputDate, InputMoney } from "../../../components/input/input";
import {
  useGenerateAutoCompleteSearch,
  useGenerateOptionsv2,
} from "../../../components/input/hook/useGenerateOptions";
import { useGetListCategoryExpense } from "../../expense-category/network/resolver";
import { useToast } from "../../../context/toast/ToastContext";
import {
  AutocompleteOption,
  SearchAutocomplete,
} from "../../../components/input/AutocompleteSearch";
import { FormatDateToJakarta } from "../../../utils/Helper";
import Input from "../../../components/input/v2/Input-v2";

interface ExpenseCategoryFormProps {
  id?: any;
}

export default function ExpenseCategoryForm({ id }: ExpenseCategoryFormProps) {
  const toast = useToast();
  const { data: dataRawDetailExpense, isLoading: loadingFetch } =
    useGetDetailExpense({
      expense_id: id,
    });
  const dataDetailExpense = dataRawDetailExpense?.data.data;
  const { mutate: mutateAdd, isLoading: loadingAdd } = useAddExpense();
  const { mutate: mutateUpdate, isLoading: loadingUpdate } = useUpdateExpense();
  const [name, setName] = useState("");
  const [expenseCategory, setExpenseCategory] =
    useState<AutocompleteOption | null>(null);
  const [keywordCategory, setKeywordCategory] = useState("");
  const [expenseCategoryPpn, setExpenseCategoryPpn] =
    useState<AutocompleteOption | null>(null);
  const [keywordCategoryPpn, setKeywordCategoryPpn] = useState("");
  const [description, setDescription] = useState("");
  const [totalExpense, setTotalExpense] = useState(0);
  const [date, setDate] = useState<any>();
  const [isHavingPpn, setIsHavingPpn] = useState(false);
  const [ppnPercetage, setPpnPercetage] = useState<number | null>(null);
  const { data: dataRawExpenseCategory, isLoading: loadingCategoryFetch } =
    useGetListCategoryExpense({
      keyword: keywordCategory,
    });
  const dataExpenseCategory = dataRawExpenseCategory?.data.data.data;
  const { data: optionsCategoryExpense } = useGenerateOptionsv2({
    keyForValue: "id",
    keyForText: "name",
    dataSource: dataExpenseCategory,
    idKey: "",
    valueKey: "",
  });
  const {
    data: dataRawExpenseCategoryPpn,
    isLoading: loadingCategoryFetchPpn,
  } = useGetListCategoryExpense({
    keyword: keywordCategoryPpn,
  });
  const dataExpenseCategoryPpn = dataRawExpenseCategoryPpn?.data.data.data;
  const { data: optionsCategoryExpensePpn } = useGenerateAutoCompleteSearch({
    keyForValue: "id",
    keyForText: "name",
    dataSource: dataExpenseCategoryPpn,
  });

  const isLoading = loadingAdd || loadingUpdate;
  const isFetch = loadingFetch;

  useEffect(() => {
    if (dataDetailExpense && dataExpenseCategory) {
      // const selectedExpense = dataExpenseCategory.find(
      //   (item) => item.id === dataDetailExpense.expense_category_id
      // );
      setName(dataDetailExpense.name);
      setDescription(dataDetailExpense.description);
      setDate(FormatDateToJakarta(dataDetailExpense.date));
      setTotalExpense(dataDetailExpense.total_expense);
      if (dataDetailExpense.expense_category) {
        setExpenseCategory({
          label: dataDetailExpense.expense_category.name,
          value: dataDetailExpense.expense_category.id,
        });
      }
    }
  }, [dataDetailExpense, dataExpenseCategory]);

  const handleOnClick = () => {
    if (id) {
      if (name && expenseCategory && description && totalExpense && date) {
        mutateUpdate({
          expense_id: id,
          name: name,
          expense_category_id: expenseCategory.value as any,
          description: description,
          total_expense: totalExpense as any,
          date: date,
          is_using_ppn: isHavingPpn,
          ppn_expense_category_id: expenseCategoryPpn?.value,
          ppn_percentage: ppnPercetage || 0,
        });
      } else {
        toast.show("Mohon melengkapi seluruh informasi");
      }
    } else {
      if (name && expenseCategory && description && totalExpense && date) {
        mutateAdd({
          name: name,
          expense_category_id: expenseCategory.value as any,
          description: description,
          total_expense: totalExpense as any,
          date: date,
          is_using_ppn: isHavingPpn,
          ppn_expense_category_id: expenseCategoryPpn?.value,
          ppn_percentage: ppnPercetage || 0,
        });
      } else {
        toast.show("Mohon melengkapi seluruh informasi");
      }
    }
  };

  if (isFetch) {
    return <Spinner />;
  }

  return (
    <Box display={"flex"} gap={2} flexDirection={"column"}>
      <TextField
        fullWidth
        label="Nama"
        placeholder="Nama"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      {/* <SearchAutocomplete
        label="Expense Kategori"
        options={optionsCategoryExpense}
        value={expenseCategory}
        onChange={(e) => {
          setExpenseCategory(e);
          console.log("hh");
        }}
        inputValue={keywordCategory}
        onInputChange={(e) => {
          console.log("zmzmz ", e);
          setKeywordCategory(e);
        }}
      /> */}
      <Input.Autocomplete
        label="Expense Kategori"
        options={optionsCategoryExpense}
        onChange={(e) => setKeywordCategory(e)}
        onClick={(e) => setExpenseCategory(e as any)}
        value={expenseCategory}
      />
      <TextField
        fullWidth
        label="Description"
        placeholder="Description"
        multiline
        rows={4}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <InputMoney
        label="Total"
        value={totalExpense}
        onChange={(e) => setTotalExpense(e)}
      />
      <InputDate
        onChange={(e) => setDate(e as any)}
        label="Tanggal"
        value={date}
      />
      {!id && (
        <FormControlLabel
          value={isHavingPpn}
          onChange={(e, v) => setIsHavingPpn(v)}
          control={<Checkbox />}
          label="Expense Dengan PPN"
        />
      )}
      {isHavingPpn && (
        <>
          <SearchAutocomplete
            label="Expense Kategori PPN"
            options={optionsCategoryExpensePpn}
            value={expenseCategoryPpn}
            onChange={(e) => setExpenseCategoryPpn(e)}
            inputValue={keywordCategoryPpn}
            onInputChange={(e) => setKeywordCategoryPpn(e)}
          />
          <TextField
            fullWidth
            label="PPN"
            placeholder="Jumlah PPN"
            value={ppnPercetage}
            onChange={(e) => {
              const v = e.target.value;
              const value = v ? parseInt(v) : null;
              setPpnPercetage(value);
            }}
            type="number"
          />
        </>
      )}

      <Box display={"flex"} justifyContent={"flex-end"} mt={2}>
        <LoadingButton
          onClick={handleOnClick}
          text="Submit"
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
}
